<template>
  <div class="text-center">
    <div class="body-bg">
      <div class="row no-gutters text-label-color font-weight-bold py-1">
        <div class="col-6">{{ $t('tooth') }}</div>
        <div class="col-6 text-capitalize">{{ $t('un') }}</div>
      </div>
    </div>
    <div class="bg-white">
      <div class="row no-gutters py-1 border-top"
           v-for="d in teeth"
           :key="`t-${d.teeth}`">
        <div class="col-6">{{ d.teeth }}</div>
        <div class="col-6">
          <div class="d-flex justify-content-center align-items-center gap-2">
            <PatientVisitToothServiceQuantityClicker :readonly="readonly"
                                                     :tooth="d.teeth"
                                                     :minAmount="minAmount"
                                                     :serviceId="serviceId"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue"
import PatientVisitToothServiceQuantityClicker
  from "@/components/parts/patients/visit/teethTab/PatientVisitToothServiceQuantityClicker.vue"

const props = defineProps({
  teeth: Array,
  service: Object,
  readonly: Boolean,
  minAmount: {
    type: Number,
    default: -1
  }
})

const serviceId = computed(() => props.service.id)
</script>
